import React from 'react';
import siteContent from '../../content/site/content.json';
const yourRightsData = siteContent.yourRights;
import * as Icons from 'lucide-react';
import { Scale, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const YourRightsSection = () => {
  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent className="w-6 h-6" /> : null;
  };

  return (
    <section id="your-rights" className="py-20 lg:py-28 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#B5541B]/5 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#B5541B]/10 px-4 py-2 rounded-full mb-6">
            <Scale className="w-5 h-5 text-[#B5541B]" />
            <span className="text-sm font-semibold text-[#B5541B] uppercase tracking-wide">Your Rights</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F1E1E] max-w-3xl mx-auto leading-tight">
            {yourRightsData.heading}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#3B3535]/70 max-w-2xl mx-auto">
            {yourRightsData.subheading}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 lg:gap-6 mb-10">
          {yourRightsData.rights.map((right, index) => (
            <div
              key={index}
              className="group flex gap-4 bg-[#FFF8F5] rounded-2xl p-6 border border-[#B5541B]/10 hover:border-[#B5541B]/30 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-[#B5541B]/10 flex items-center justify-center text-[#B5541B] flex-shrink-0 group-hover:bg-[#B5541B] group-hover:text-white transition-all duration-300">
                {getIcon(right.icon)}
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#1F1E1E] mb-1">{right.name}</h3>
                <p className="text-sm text-[#3B3535]/70 leading-relaxed">{right.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/compliance" 
            className="inline-flex items-center gap-2 text-[#B5541B] hover:text-[#8B3F14] font-semibold transition-colors group"
          >
            See the full list of regulations that protect you
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default YourRightsSection;
